import store from '@/store';

export default async (_, __, next) => {
	const envs = store.state.envs;

	if (!envs) {
		store.dispatch('getEnvironmentVariables');
	}

	next();
};
